import "./static/normalize.css"
import "./static/styles.css"
